(function () {
  // Menu mobile
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () { nav.classList.toggle('is-open'); });
  }

  // Bloc d'achat : choix du pack + galerie
  document.querySelectorAll('[data-buy]').forEach(function (buy) {
    var idInput = buy.querySelector('[data-variant-id]');
    var priceEl = buy.querySelector('[data-price]');
    var compareEl = buy.querySelector('[data-compare]');
    var btn = buy.querySelector('[data-add]');
    var btnPrice = buy.querySelector('[data-btn-price]');

    buy.querySelectorAll('input[name="pack"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        buy.querySelectorAll('.pack').forEach(function (p) { p.classList.remove('is-selected'); });
        radio.closest('.pack').classList.add('is-selected');
        if (idInput) idInput.value = radio.value;
        if (priceEl) priceEl.textContent = radio.dataset.price;
        if (compareEl) {
          if (radio.dataset.compare) { compareEl.textContent = radio.dataset.compare; compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        if (btn) {
          var ok = radio.dataset.available === 'true';
          btn.disabled = !ok;
          if (ok) { btn.innerHTML = 'Ajouter au panier · <span data-btn-price>' + radio.dataset.price + '</span>'; }
          else { btn.textContent = 'Épuisé'; }
        }
        if (window.history && window.history.replaceState && buy.closest('.template-product')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    buy.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = thumb.dataset.thumb;
        buy.querySelectorAll('[data-slide]').forEach(function (s) { s.classList.toggle('is-active', s.dataset.slide === i); });
        buy.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  });

  // Panier : afficher "Mettre à jour" quand une quantité change
  var update = document.querySelector('[data-update]');
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    q.addEventListener('change', function () { if (update) update.hidden = false; });
  });
})();

// Calculateur d'économies
(function () {
  var root = document.querySelector('[data-calc]');
  if (!root) return;
  var section = root.closest('.calc');
  var osmo = parseFloat(root.dataset.osmo) || 329;
  var liters = parseFloat(root.dataset.liters) || 1.5;
  var people = 2;
  var peopleOut = root.querySelector('[data-people]');
  var priceIn = root.querySelector('[data-price-input]');
  var priceOut = root.querySelector('[data-price-out]');
  var fmt = function (n, d) { return n.toLocaleString('fr-FR', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); };
  function render() {
    var price = parseFloat(priceIn.value);
    var litersYear = people * liters * 365;
    var bottles = Math.round(litersYear / 1.5);
    var euros = bottles * price;
    peopleOut.textContent = people;
    priceOut.textContent = fmt(price, 2) + ' €';
    section.querySelector('[data-kg]').textContent = fmt(Math.round(litersYear));
    section.querySelector('[data-bottles]').textContent = fmt(bottles);
    section.querySelector('[data-euros]').textContent = fmt(Math.round(euros)) + ' €';
    var months = euros > 0 ? Math.ceil(osmo / (euros / 12)) : 0;
    section.querySelector('[data-payback]').textContent = months > 0 ? (months <= 24 ? months + ' mois' : 'plus de 2 ans') : '—';
  }
  root.querySelectorAll('[data-step]').forEach(function (b) {
    b.addEventListener('click', function () { people = Math.min(8, Math.max(1, people + parseInt(b.dataset.step, 10))); render(); });
  });
  priceIn.addEventListener('input', render);
  render();
})();
